import React, { useState } from "react";
import styles from "./DateInput.module.css";
import { FaCalendarAlt, FaClock } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import { DatePicker } from "antd";
import TextComponent from "../textComponent/TextComponent";
import { GrFormClose } from "react-icons/gr";

const DateInput = (props) => {
  return (
    <div className={`${styles.main_input} ${props?.className}`}>
      {props?.label ? (
        <TextComponent className={` ${styles.label} ${props?.labelClass} `}>
          {props?.label}
        </TextComponent>
      ) : null}

      <DatePicker
         style={{ border: "1px solid var(--input-border)", boxShadow: "none" }}
        placeholder={props?.placeholder ? props?.placeholder : "Select Date"}
        value={props?.value}
        //   defaultValue={props?.defaultValue}
        use12Hours
        format="MM-DD-YYYY"
        onChange={props?.onChange}
        suffixIcon={props?.icon}
        className={`${styles.inner_input} ${props?.inputClass}`}
        inputReadOnly
        clearIcon={
          <div className={styles.clearIconBtn}>
            <GrFormClose
              className={styles.clearIcon}
              style={{ color: "var(--secondary-color)" }}
            />
          </div>
        }
      />
    </div>
  );
};

export default DateInput;
